const HOME_NEWS_SHORTCUT_TIMEZONE = "America/Fortaleza";

const CUTOFF = {
  year: 2026,
  month: 5,
  day: 10,
  hour: 23,
  minute: 59,
  second: 59,
};

function getZonedDateParts(date: Date, timeZone: string) {
  const formatter = new Intl.DateTimeFormat("en-CA", {
    timeZone,
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: false,
  });

  const parts = formatter.formatToParts(date);
  const map = Object.fromEntries(parts.map((part) => [part.type, part.value]));

  return {
    year: Number(map.year),
    month: Number(map.month),
    day: Number(map.day),
    hour: Number(map.hour),
    minute: Number(map.minute),
    second: Number(map.second),
  };
}

function toComparableNumber(value: {
  year: number;
  month: number;
  day: number;
  hour: number;
  minute: number;
  second: number;
}) {
  return Number(
    `${value.year}${String(value.month).padStart(2, "0")}${String(value.day).padStart(2, "0")}${String(value.hour).padStart(2, "0")}${String(value.minute).padStart(2, "0")}${String(value.second).padStart(2, "0")}`
  );
}

export function shouldShowHomeNewsShortcut(now: Date = new Date()) {
  const zoned = getZonedDateParts(now, HOME_NEWS_SHORTCUT_TIMEZONE);
  return toComparableNumber(zoned) <= toComparableNumber(CUTOFF);
}
